/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { isOboRequest } from '@msdyn365-commerce/core-internal';
import { IMsdyn365PvaChatConnectorData } from './msdyn365-pva-chat-connector.data';
import { IMsdyn365PvaChatConnectorConfig, IMsdyn365PvaChatConnectorProps } from './msdyn365-pva-chat-connector.props.autogenerated';

export interface IPvaChatConnectorViewProps extends IMsdyn365PvaChatConnectorProps<IMsdyn365PvaChatConnectorData> {
    config: IMsdyn365PvaChatConnectorConfig;
}

/**
 * PvaChatConnector component
 * @extends {React.PureComponent<IPvaChatConnectorProps<IPvaChatConnectorData>>}
 */
class PvaChatConnector extends React.PureComponent<IMsdyn365PvaChatConnectorProps<IMsdyn365PvaChatConnectorData>> {
    // Loads CDN version of Botframework-Webchat library
    public componentDidMount(): void {
        if (isOboRequest(this.props.context.request)) {
            return;
        }

        const url = this.props.config.botFrameworkCDNURL || this.props.context.app.config.pvaChatConnectorBotFrameworkCDNURL;
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.crossOrigin = 'anonymous';
        document.body.appendChild(script);
    }

    public render(): JSX.Element | null {
        if (isOboRequest(this.props.context.request)) {
            return null;
        }

        return this.props.renderView(this.props);
    }
}

export default PvaChatConnector;
